module.exports = __webpack_public_path__ + "media/images/teams/BENEVENTO-dc53d63b5bd7991a6ceecaf4c43d84cb.png";